// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__R-ppF","header":"PatientBlock_header__1e67V","label":"PatientBlock_label__3Lzka","option":"PatientBlock_option__1NPOC"};